'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var SegmentedControl = (function (_React$Component) {
    _inherits(SegmentedControl, _React$Component);

    function SegmentedControl(props) {
        _classCallCheck(this, SegmentedControl);

        _get(Object.getPrototypeOf(SegmentedControl.prototype), 'constructor', this).call(this, props);
        this.displayName = 'SegmentedControl';
    }

    _createClass(SegmentedControl, [{
        key: 'onChange',
        value: function onChange(value) {
            this.props.onChange(value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this = this;

            var componentClassName = (0, _classnames2['default'])('SegmentedControl', 'SegmentedControl--' + this.props.type, {
                'SegmentedControl--equal-widths': this.props.equalWidthSegments
            }, this.props.className);

            var options = this.props.options.map(function (op) {
                var buttonClassName = (0, _classnames2['default'])('SegmentedControl__button', {
                    'is-selected': op.value === _this.props.value
                });

                return _react2['default'].createElement(
                    'span',
                    { key: 'option-' + op.value, className: 'SegmentedControl__item' },
                    _react2['default'].createElement(
                        'button',
                        {
                            type: 'button',
                            onClick: _this.onChange.bind(_this, op.value),
                            className: buttonClassName
                        },
                        op.label
                    )
                );
            });

            return _react2['default'].createElement(
                'div',
                { className: componentClassName },
                options
            );
        }
    }]);

    return SegmentedControl;
})(_react2['default'].Component);

SegmentedControl.propTypes = {
    className: _propTypes2['default'].string,
    equalWidthSegments: _propTypes2['default'].bool,
    onChange: _propTypes2['default'].func.isRequired,
    options: _propTypes2['default'].array.isRequired,
    type: _propTypes2['default'].oneOf(['default', 'muted', 'danger', 'info', 'primary', 'success', 'warning']),
    value: _propTypes2['default'].string
};

SegmentedControl.defaultProps = {
    type: 'default'
};

module.exports = SegmentedControl;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/SegmentedControl.js
// module id = 333
// module chunks = 0